export enum FeatureFlag {
    EPISODES_OF_CARE = 'EPISODES_OF_CARE',
    ORDERS = 'ORDERS',

    // Booking Flow
    SHOW_MAP_IN_BOOKING_FLOW = 'SHOW_MAP_IN_BOOKING_FLOW',

    // Partner Axle V2 Features
    ALL_VISITS_MAP = 'ALL_VISITS_MAP',
    DASHBOARD_CLINICIAN_HOME_PINS_ON_MAPS = 'DASHBOARD_CLINICIAN_HOME_PINS_ON_MAPS',
    DASHBOARD_CLINICIAN_DETAILS_HEADER_V2 = 'DASHBOARD_CLINICIAN_DETAILS_HEADER_V2',
    CREATE_EPISODE_VISIT_FLOW = 'CREATE_EPISODE_VISIT_FLOW',
    CREATE_URGENT_VISIT_FLOW = 'CREATE_URGENT_VISIT_FLOW',
    CARE_TEAM_EFFECTIVE_DATES = 'CARE_TEAM_EFFECTIVE_DATES',
    CARE_TEAM_ROLE = 'CARE_TEAM_ROLE',
    DASHBOARD_CARE_TEAM_RECOMMENDATION_FLOW = 'DASHBOARD_CARE_TEAM_RECOMMENDATION_FLOW',
    DASHBOARD_HOME_VIEW = 'DASHBOARD_HOME_VIEW',
    DASHBOARD_LIVE_VIEW_SIDEBAR = 'DASHBOARD_LIVE_VIEW_SIDEBAR',
    DASHBOARD_TAG_FILTERS_ON_HOMEPAGE = 'DASHBOARD_TAG_FILTERS_ON_HOMEPAGE',
    GLOBAL_NAVIGATION_V2 = 'GLOBAL_NAVIGATION_V2',
    GLOBAL_PATIENT_COMMS = 'GLOBAL_PATIENT_COMMS',
    PATIENT_DETAILS_PAGE_V2 = 'PATIENT_DETAILS_PAGE_V2',
    PATIENT_INTAKE_CAPACITY_PAGE = 'PATIENT_INTAKE_CAPACITY_PAGE',
    PATIENTS_LIST_PAGE_SHOW_BENEFIT_ADMIT_COLUMNS = 'PATIENTS_LIST_PAGE_SHOW_BENEFIT_ADMIT_COLUMNS',
    DASHBOARD_PATIENT_TAGS_IN_TABLES = 'DASHBOARD_PATIENT_TAGS_IN_TABLES',
    PATIENTS_LIST_PAGE_V2 = 'PATIENTS_LIST_PAGE_V2',
    DASHBOARD_TAG_FILTERS_ON_PATIENTS_PAGE = 'DASHBOARD_TAG_FILTERS_ON_PATIENTS_PAGE',
    DASHBOARD_COMMAND_PALETTE_MVP = 'DASHBOARD_COMMAND_PALETTE_MVP',
    DASHBOARD_COMMAND_PALETTE_QUICK_ACTIONS = 'DASHBOARD_COMMAND_PALETTE_QUICK_ACTIONS',
    REASSIGN_VISITS_FLOW_V2 = 'REASSIGN_VISITS_FLOW_V2',
    DASHBOARD_VISIT_REASSIGNMENT_FLOW = 'DASHBOARD_VISIT_REASSIGNMENT_FLOW',
    DASHBOARD_BULK_VISIT_REASSIGNMENT = 'DASHBOARD_BULK_VISIT_REASSIGNMENT',
    VISITS_LIST_PAGE_V2 = 'VISITS_LIST_PAGE_V2',

    // Bulk Cancellation
    DASHBOARD_BULK_CANCELLATION_ALL_VISITS = 'DASHBOARD_BULK_CANCELLATION_ALL_VISITS',
    DASHBOARD_BULK_CANCELLATION_PATIENT_EPISODE_VIEW = 'DASHBOARD_BULK_CANCELLATION_PATIENT_EPISODE_VIEW',
    DASHBOARD_BULK_REASSIGNMENT_PATIENT_EPISODE_VIEW = 'DASHBOARD_BULK_REASSIGNMENT_PATIENT_EPISODE_VIEW',

    // Edit Visit Services
    DASHBOARD_EDIT_VISIT_SERVICES_DIALOG = 'DASHBOARD_EDIT_VISIT_SERVICES_DIALOG',

    // Edit Visit Fulfillment Window
    DASHBOARD_EDIT_VISIT_FULFILLMENT_WINDOW_DIALOG = 'DASHBOARD_EDIT_VISIT_FULFILLMENT_WINDOW_DIALOG',

    // Inline service-type (Visit Type) override in the reassignment flow
    DASHBOARD_REASSIGN_SERVICE_TYPE_OVERRIDE = 'DASHBOARD_REASSIGN_SERVICE_TYPE_OVERRIDE',
    DASHBOARD_REASSIGN_TOP_RECOMMENDATIONS = 'DASHBOARD_REASSIGN_TOP_RECOMMENDATIONS',
    DASHBOARD_DS_SHARED_FACTORS_SUMMARY = 'DASHBOARD_DS_SHARED_FACTORS_SUMMARY',

    // Microsoft OAuth
    MICROSOFT_OAUTH = 'MICROSOFT_OAUTH',

    // Bulk Cancellation
    DASHBOARD_BULK_CANCELLATION_WORK_QUEUE = 'DASHBOARD_BULK_CANCELLATION_WORK_QUEUE',

    // Hides the clinicians column on the Territories page and omits clinicians from its query.
    DASHBOARD_HIDE_CLINICIANS_FROM_TERRITORY_LIST = 'DASHBOARD_HIDE_CLINICIANS_FROM_TERRITORY_LIST',

    // Wide-table treatment on the All Visits table.
    DASHBOARD_TABLE_HORIZONTAL_BUTTONS = 'DASHBOARD_TABLE_HORIZONTAL_BUTTONS',
    DASHBOARD_TABLE_PINNED_ACTIONS = 'DASHBOARD_TABLE_PINNED_ACTIONS',
    DASHBOARD_TABLE_CONDENSED_PADDING = 'DASHBOARD_TABLE_CONDENSED_PADDING',
    // Two-sided matching criteria (patient/clinician needs and attributes).
    MATCHING_CRITERIA = 'MATCHING_CRITERIA',

    // Alt/Option + drag on the clinician schedules calendar creates a shift block
    // instead of a shift.
    DASHBOARD_SHIFT_BLOCK_DRAG_SUPPORT = 'DASHBOARD_SHIFT_BLOCK_DRAG_SUPPORT',

    // Materialized shift occurrences, which shift-coverage visit filters read from.
    SHIFT_OCCURRENCE_MATERIALIZATION = 'SHIFT_OCCURRENCE_MATERIALIZATION',

    // Dragging a dialog by its header, keyboard nudging, and double-click to recenter.
    DASHBOARD_DIALOG_REPOSITIONING = 'DASHBOARD_DIALOG_REPOSITIONING',
    // Dialogs that have a version on the dialog shell render it instead of the original chrome.
    DASHBOARD_EDIT_CLINICIAN_TEAM_DIALOG_V2 = 'DASHBOARD_EDIT_CLINICIAN_TEAM_DIALOG_V2',

    // Flexible booking renders as a tab beside availability instead of in a dialog.
    DASHBOARD_FLEXIBLE_BOOKING_TABS = 'DASHBOARD_FLEXIBLE_BOOKING_TABS',

    // Records the page each tab is on while authenticated, so that a session ending
    // returns the tab there on the next sign-in.
    DASHBOARD_STORE_TAB_STATE_ON_LOGOUT = 'DASHBOARD_STORE_TAB_STATE_ON_LOGOUT',

    // Mirrors filter selections held in browser storage to a backend row, so a
    // browser that has none starts from the selection last made elsewhere.
    DASHBOARD_PERSISTED_PAGE_FILTERS = 'DASHBOARD_PERSISTED_PAGE_FILTERS',

    // Employment type and inactive status chips beside each care team member.
    DASHBOARD_SHOW_CARE_TEAM_MEMBER_ATTRIBUTE_CHIPS = 'DASHBOARD_SHOW_CARE_TEAM_MEMBER_ATTRIBUTE_CHIPS',

    // Asks the clinician column's decision support for only the winning clinician and a run id,
    // reading the full recommendation set back per visit when a cell is opened.
    USE_VISIT_ASSIGNMENT_CACHING = 'USE_VISIT_ASSIGNMENT_CACHING',

    // Shows a provisional winner from the patient's care team while the run over every clinician is
    // outstanding, on single-patient queues only and only alongside USE_VISIT_ASSIGNMENT_CACHING.
    DASHBOARD_VISIT_REC_FAST_CHECK_CARE_TEAM = 'DASHBOARD_VISIT_REC_FAST_CHECK_CARE_TEAM',

    DASHBOARD_SHOW_LEGACY_PATIENT_AVAILABILITY = 'DASHBOARD_SHOW_LEGACY_PATIENT_AVAILABILITY',

    // Embeds the Omni dashboard on the Insights page in place of Explo.
    DASHBOARD_OMNI_INSIGHTS = 'DASHBOARD_OMNI_INSIGHTS',

    DASHBOARD_WORK_QUEUE_FULL_DESCRIPTIONS = 'DASHBOARD_WORK_QUEUE_FULL_DESCRIPTIONS',

    // Demo-only comms drawer on patient details, backed by local storage. Also requires is_demo_org.
    DEMO_DASHBOARD_PATIENT_COMMS_DRAWER = 'DEMO_DASHBOARD_PATIENT_COMMS_DRAWER',
    // Demo-only LUPA tracking: period status on the episode chip, the projected-LUPA bar on the
    // calendar rail, and the Projected LUPA workqueue.
    DEMO_DASHBOARD_LUPA_TRACKING = 'DEMO_DASHBOARD_LUPA_TRACKING',

    // Reservation workflows: creating, claiming, and managing reservations.
    RESERVATIONS_FLOW = 'RESERVATIONS_FLOW',
}
